module.exports = __webpack_public_path__ + "media/images/athletes/3569-f0ab14bf1e5390f133c5cf32bd013ac9.png";